module.exports = __webpack_public_path__ + "static/media/googleAssistantLogo.e79c6392.webp";